import { BrowserRouter , Routes, Route } from "react-router-dom";
import MainLayout from "../Components/Layout/MainLayout";
import Home from "../Components/Home";
import StoryDetail from "../Components/StoryDetail";
import IssuePage from "../Components/IssuePage";
import LatestIssue from "../Components/LatestIssue";
import SidebarMenu from "../Components/SidebarMenu";
import { HelmetProvider } from 'react-helmet-async';

const AppRoutes = () => {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <MainLayout>
        <Routes>  
           <Route path="/" element={<LatestIssue />} />
           <Route path="/:year/:month/:issue" element={<IssuePage />} />
           <Route path="/:year/:month/:issue/:title" element={<StoryDetail key={window.location.pathname}  />} />   
        </Routes>
      </MainLayout>
    </BrowserRouter>
    </HelmetProvider>
  );
};

export default AppRoutes;





// import { BrowserRouter , Routes, Route } from "react-router-dom";
// import MainLayout from "../Components/Layout/MainLayout";
// import Home from "../Components/Home";
// // import About from "../pages/About";
// // import Contact from "../pages/Contact";
// // import Products from "../pages/Products";
// // import NotFound from "../pages/NotFound";

// const AppRoutes = () => {
//   return (
//     <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<MainLayout />} >
//           <Route index element={<Home />} />
//           {/* <Route path="/about" element={<About />} /> */}
//           {/* <Route path="/products" element={<Products />} /> */}
//           {/* <Route path="/contact" element={<Contact />} /> */}
//           {/* <Route path="*" element={<NotFound />} /> */}
//           </Route>
//         </Routes>
//     </BrowserRouter>
//   );
// };

// export default AppRoutes;

